"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.foundation_size = void 0;
exports.foundation_size = {
    tiny: {
        size_tiny_none: '0px',
        size_tiny_half: '0.5px',
        size_tiny_1: '1px',
        size_tiny_2: '2px',
        size_tiny_3: '3px',
        size_tiny_4: '4px',
        size_tiny_5: '5px',
        size_tiny_6: '6px',
        size_tiny_7: '7px',
        size_tiny_8: '8px',
    },
    small: {
        size_small_10: '10px',
        size_small_12: '12px',
        size_small_14: '14px',
        size_small_16: '16px',
        size_small_18: '18px',
        size_small_20: '20px',
        size_small_22: '22px',
        size_small_24: '24px',
        size_small_26: '26px',
    },
    medium: {
        size_medium_28: '28px',
        size_medium_30: '30px',
        size_medium_32: '32px',
        size_medium_36: '36px',
        size_medium_40: '40px',
        size_medium_44: '44px',
        size_medium_48: '48px',
        size_medium_52: '52px',
        size_medium_56: '56px',
        size_medium_60: '60px',
    },
    large: {
        size_large_64: '64px',
        size_large_68: '68px',
        size_large_72: '72px',
        size_large_76: '76px',
        size_large_80: '80px',
        size_large_84: '84px',
        size_large_88: '88px',
        size_large_92: '92px',
        size_large_96: '96px',
        size_large_100: '100px',
    },
    xlarge: {
        size_xlarge_104: '104px',
        size_xlarge_108: '108px',
        size_xlarge_112: '112px',
        size_xlarge_116: '116px',
        size_xlarge_120: '120px',
        size_xlarge_124: '124px',
        size_xlarge_128: '128px',
        size_xlarge_132: '132px',
        size_xlarge_136: '136px',
        size_xlarge_140: '140px',
    },
    screen: {
        size_screen_320: '320px',
        size_screen_768: '768px',
        size_screen_1024: '1024px',
        size_screen_1280: '1280px',
        size_screen_1600: '1600px',
    },
    percent: {
        size_percent_0: '0%',
        size_percent_10: '10%',
        size_percent_20: '20%',
        size_percent_30: '30%',
        size_percent_50: '50%',
        size_percent_70: '70%',
        size_percent_80: '80%',
        size_percent_90: '90%',
        size_percent_100: '100%',
    },
};
//# sourceMappingURL=global.js.map